import { Contextune } from './Contextune.js';

(window as unknown as { Contextune: typeof Contextune }).Contextune = Contextune;
